import { func } from "prop-types";
import { getStaticImg, scrollTo } from "../../../../utils/function";
import { Button, Text, Wave } from "../../../atoms";

const BannerBottom = ({
  titleMobile = <>Waktunya sekolahmu angkat piala!</>,
  titleDesktop = "Waktunya sekolahmu angkat piala!",
  subTitleMobile = "",
}) => {
  const handleClicks = (e) => {
    // window.location.href = e;
    window.open(e, "_blank");
  };
  return (
    <>
      <div className="banner-bottom2">
        <div className="banner-bottom2__content">
          <div className="banner-bottom2__content-title">
            <Text weight="bold" className="banner-bottom2__content-title-el">
              {titleMobile}
            </Text>
          </div>
          <div className="banner-bottom2__content-image">
            {image.map((e) => {
              return (
                <img
                  src={getStaticImg(e.path)}
                  className={e.class}
                  alt={e.path}
                />
              );
            })}
          </div>
          <div className="dialogWrapper">
            <div className="banner-bottom2__content-dialog">
              <Text
                weight="bold"
                className="banner-bottom2__content-dialog-subTitle"
              >
                {subTitleMobile}
              </Text>

              <Text
                weight="bold"
                color="white"
                className="banner-bottom2__content-dialog-title"
              >
                {titleDesktop}
              </Text>
              {/* <Button
              className="banner-bottom2__content-dialog-button"
              variant="primary-orange"
              size="large"
              onClick={() => scrollTo("daftar-lomba")}
            >
              Daftar Sekarang!
            </Button> */}
            </div>
            <div className="banner-bottom2__content-info">
              <Text
                color="white"
                className="banner-bottom2__content-info-subTitle"
              >
                Informasi lebih lanjut hubungi:
              </Text>
              <div className="imagesWrapper">
                <div className="banner-bottom2__content-info-images">
                  {images.map((e, i) => {
                    return (
                      <div
                        key={e.name}
                        className={`banner-bottom__content-info-image img-${i}`}
                        onClick={() => handleClicks(e.link)}
                      >
                        <img
                          src={getStaticImg(e.path)}
                          alt={e.name}
                          className="banner-bottom2__content-info-image-el"
                        />
                        <Text
                          weight="bold"
                          color="white"
                          className="banner-bottom2__content-info-text"
                        >
                          {e.text}
                        </Text>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="backdrop-footer" style={{ backgroundColor: "#89c353" }} /> */}
    </>
  );
};
export default BannerBottom;

const images = [
  {
    path: "illustration/Mail.svg",
    name: "Mail",
    text: "event@byu.id",
    link: "mailto:event@byu.id",
  },
  {
    path: "illustration/Instagram.svg",
    name: "Instagram",
    text: "@byu.id",
    link: "https://www.instagram.com/byu.id/",
  },
  {
    path: "illustration/WhatsApp.svg",
    name: "WhatsApp",
    text: (
      <div style={{ display: "inline-flex" }}>
        085155333333
        <p className="additionalText"> &nbsp;(WA Only)</p>
      </div>
    ),
    link: `https://wa.me/6285155333333`,
  },
];

const image = [
  {
    path: "illustration/pialaAssembled.svg",
    class: "banner-bottom2__content-image-el-m",
  },
  {
    path: "illustration/pialaAssembled-d.svg",
    class: "banner-bottom2__content-image-el-d",
  },
];
